
/*
 * @Author: xieyu7
 * @Date: 2019-03-15 16:51:02
 * @Last Modified by: hanjin
 * @Last Modified time: 2022-06-23 15:10:54
 */
import request from '../utils/service'
import { getLocal } from '../utils/index'
const url = './coupon/v2/api/'
const api = {
  // collect page api
  getStarParkings: function(params) {
    return request({
      url: '/dealer/v2/api/collectParks',
      method: 'get',
      params
    })
  },
  collectStations: function(params) { // 获取充电站收藏列表
    return request({
      url: '/cps/v2/api/collectStations',
      method: 'get',
      params
    })
  },
  getUsertel: function() { // 获取停车场收藏列表
    return request({
      url: '/auth/v2/api/driver/loginInfo',
      method: 'get'
    })
  },
  getZigbeeLockState: function(data) {
    return request({
      url: '/api/v1/getZigbeeLockState',
      method: 'post',
      data: Object.assign({
        thirdId: localStorage.getItem('openId')
      }, data)
    })
  },
  controlZigbeeLock: function(data) {
    return request({
      url: '/api/v1/controlZigbeeLock',
      method: 'post',
      data: Object.assign({
        thirdId: localStorage.getItem('openId')
      }, data)
    })
  },
  // collect page api
  unStarPark: function(data) { // 删除收藏停车场
    return request({
      url: '/dealer/v2/api/collectParks/' + data.parkIds,
      method: 'delete'
    })
  },
  deleteCharge(params) { // 删除收藏充电站
    return request({
      url: `/cps/v2/api/collectStations/${params}`,
      method: 'delete'
    })
  },
  // mine page api
  getUserCenterData: function() {
    return request({
      url: '/api/v1/getUserCenterData',
      method: 'post',
      data: {
        thirdId: localStorage.getItem('openId')
      }
    })
  },
  // fllowManage page api
  getEvasionCarList: function(data) {
    return request({
      url: '/api/v1/getEvasionCarList',
      method: 'post',
      data: data
    })
  },
  // fllowManage page api
  revert: function(data) {
    return request({
      url: '/api/v1/cancelControl',
      method: 'post',
      data: data
    })
  },
  // discount page api
  getUserCouponList: function(params) {
    console.log(url + 'userCoupons')
    return request({
      url: url + 'userCoupons',
      method: 'get',
      params
    })
  },
  getVcode: function(data) { // 获取短信验证码
    return request({
      url: '/driver/v2/api/sendVerifyCode',
      method: 'post',
      data: Object.assign(data,
        {
          thirdId: localStorage.getItem('openId')
        })
    })
  },
  getVcodeAuth: function(data) { // 获取短信验证码
    return request({
      url: '/driver/v2/api/sendVerifyCodeAuth',
      method: 'post',
      data: Object.assign(data,
        {
          thirdId: localStorage.getItem('openId')
        })
    })
  },
  bindPhone: function(data) {
    return request({
      url: '/api/v1/bindPhone',
      method: 'post',
      data: data
    })
  },
  updatePhone: function(params) {
    return request({
      url: '/driver/v2/api/phone',
      method: 'put',
      data: params
    })
  },
  getuserDetailInfo: function() {
    return request({
      url: '/api/v1/getUserDetailInfo',
      method: 'post',
      data: {
        type: 1,
        thirdId: getLocal('openId')
      }
    })
  },
  updateUserInfo: function(data) {
    return request({
      url: '/api/v1/updateDriverUserInfo',
      method: 'post',
      data: Object.assign(data,
        {
          thirdId: localStorage.getItem('openId')
        })
    })
  },
  getUserLoginState: function() {
    return request({
      url: '/api/v1/getLoginState',
      method: 'post',
      data: { thirdId: localStorage.getItem('openId') }
    })
  },
  getMenuConfig: function() {
    return request({
      url: '/basic/v2/api/menuConfigs',
      method: 'get'
    })
  },
  updateNickname: function(params) {
    return request({
      url: '/driver/v2/api/nickName',
      method: 'put',
      data: params
    })
  },
  // 一键登录绑定手机号码
  getBindPhone: function(data) {
    return request({
      url: '/driver/v2/api/bindPhone',
      method: 'post',
      data: data
    })
  },
  // 获取应用配置
  getParamConfigs: function() {
    return request({
      url: '/basic/v2/api/paramConfigs',
      method: 'get'
    })
  }

}

export default api
